import {Api, ApiExport} from '../../../Api.js'

const RESOURCE = 'account'

export default {
    resource: RESOURCE,
    prefix: 'fidelity/',
    export() {

        /*
        return window.axios({
            url: window.axios.defaults.baseURL + '/' + this.prefix + this.resource + '/export',
            method: 'GET',
            responseType: 'blob', // important
        });*/

        return ApiExport().get(this.prefix + this.resource + '/export',
            {
                responseType: 'blob', // important
            });

    },
    query(query) {
        return Api().get(this.prefix + this.resource + (query ? query : ''))
    },
    get(id) {
        return Api().get(this.prefix + this.resource + '/' + id)
    },
    create(data) {
        return Api().post(this.prefix + this.resource, data)
    },
    update(id, data) {
        return Api().put(this.prefix + this.resource + '/' + id, data)
    },
    delete(id) {
        return Api().delete(this.prefix + this.resource + '/' + id)
    }
}


// WEBPACK FOOTER //
// ./src/modules/fidelity/account/AccountService.js